import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading'
import AWSAPI from '../../../../common/AWSAPI'

class TaikyoSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false}
    this.systemSettingName = 'TaikyoSetting'
  }
  // 建退協掛金は後発の設定項目で、まだ一度も登録されていない環境では
  // systemSettings に行が存在せず get が data:null を返す。その場合に
  // 画面が壊れないよう、空なら入力用の1行を用意する（行追加「＋」は各行内のため最低1行必要）。
  loadDefaultSetting () {
    const onSuccess = (res) => {
      const data = res.body && res.body.data ? res.body.data : null
      let defaultSetting = (data && Array.isArray(data.systemSettingValue)) ? data.systemSettingValue : []
      if (defaultSetting.length === 0) {
        defaultSetting = [{ startMonth: this.getIntYM(), endMonth: this.getIntYM(), tanka: null }]
      }
      this.setState({
        isLoaded: true,
        TaikyoSetting: defaultSetting,
        TaikyoSettingInputData: JSON.parse(JSON.stringify(defaultSetting))
      })
    }
    const params = {
      command: 'get',
      systemSettingName: this.systemSettingName
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  onInsert (offset) {
    offset = Number(offset)
    const taikyoTankaList = this.getSettingData()
    taikyoTankaList.splice(offset + 1, 0,
      {
        startMonth: this.getIntYM(),
        endMonth: this.getIntYM(),
        tanka: null
      }
    )
    this.setState({
      TaikyoSetting: taikyoTankaList,
      TaikyoSettingInputData: JSON.parse(JSON.stringify(taikyoTankaList))
    })
  }
  onDelete (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const taikyoTankaList = this.getSettingData()
        taikyoTankaList.splice(offset, 1)
        this.setState({
          TaikyoSetting: taikyoTankaList,
          TaikyoSettingInputData: JSON.parse(JSON.stringify(taikyoTankaList))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const taikyoTankaList = this.getSettingData()
      taikyoTankaList.splice(offset - 1, 2, taikyoTankaList[offset], taikyoTankaList[offset - 1])
      this.setState({
        TaikyoSetting: taikyoTankaList,
        TaikyoSettingInputData: JSON.parse(JSON.stringify(taikyoTankaList))
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    const taikyoTankaList = this.getSettingData()
    if (offset < taikyoTankaList.length - 1) {
      offset++
      taikyoTankaList.splice(offset - 1, 2, taikyoTankaList[offset], taikyoTankaList[offset - 1])
      this.setState({
        TaikyoSetting: taikyoTankaList,
        TaikyoSettingInputData: JSON.parse(JSON.stringify(taikyoTankaList))
      })
    }
  }
  getEditor (index, attributeName) {
    const value = this.state.TaikyoSettingInputData[index][attributeName] ? this.state.TaikyoSettingInputData[index][attributeName] : ''
    return (
      <input type='text' name={attributeName} value={value} onChange={(e) => this.changeTaikyoData(index, attributeName, e)} />
    )
  }
  changed (index, attributeName, e) {
    const TaikyoSetting = this.state.TaikyoSetting
    TaikyoSetting[index][attributeName] = parseInt(e.target.value)
    this.setState({
      TaikyoSetting: TaikyoSetting,
      TaikyoSettingInputData: JSON.parse(JSON.stringify(TaikyoSetting))
    })
  }
  changeTaikyoData (index, attributeName, e) {
    const TaikyoSetting = this.state.TaikyoSetting
    const TaikyoSettingInputData = this.state.TaikyoSettingInputData
    let changedValue = e.target.value

    // 数値と小数点以外を除く
    changedValue = changedValue.replace(/[^0-9.]/g, '')
    // input用データ
    TaikyoSettingInputData[index][attributeName] = changedValue
    // 保存用データ（小数を含む整数にする）
    TaikyoSetting[index][attributeName] = parseFloat(changedValue)
    this.setState({
      TaikyoSetting: TaikyoSetting,
      TaikyoSettingInputData: TaikyoSettingInputData
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const taikyoTankaList = this.getSettingData()
    const yearMonthList = this.getYMList(6, 201509).reverse()
    const yearMonthListToShow = []
    yearMonthList.forEach(ym => {
      yearMonthListToShow.push(
        <option key={this.uuid()} value={ym.id}>{ym.name}</option>
      )
    })
    const taikyoTankaListToShow =
    taikyoTankaList.map((taikyoTanka, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td><select value={taikyoTanka.startMonth} onChange={(e) => this.changed(index, 'startMonth', e)} >{yearMonthListToShow}</select></td>
          <td><select value={taikyoTanka.endMonth} onChange={(e) => this.changed(index, 'endMonth', e)} >{yearMonthListToShow}</select></td>
          <td>{this.getEditor(index, 'tanka')}</td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsert.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDelete.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUp.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDown.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>建退共掛金</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            <table>
              <thead>
                <tr>
                  <th className='kw-ds-no' />
                  <th className='kw-ds-start-month' />
                  <th className='kw-ds-end-month' />
                  <th className='kw-ds-ryouritsu' />
                  <th className='kw-ds-gyou-sousa' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className='kw-ds-no'>No.</th>
                  <th>適用開始年月</th>
                  <th>適用終了年月</th>
                  <th>掛金単価(円/日)</th>
                  <th className='kw-ds-gyou-sousa'>行操作</th>
                </tr>
                {taikyoTankaListToShow}
              </tbody>
            </table>
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default TaikyoSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/TaikyoSetting.js